import { apiClient, handleResponse } from './axios';

async function addExamSubject(body) {
  try {
    const response = await apiClient
      .post('/examsubject', body);
    const examSubject = await handleResponse(response);
    return examSubject;
  } catch (error) {
    return error.response;
  }
}

async function getExamSubject(examSubjectId) {
  try {
    const response = await apiClient
      .get(`/examsubject/${examSubjectId}`);
    const examSubject = await handleResponse(response);
    return examSubject;
  } catch (error) {
    return error.response;
  }
}

async function getAllExamSubjects() {
  try {
    const response = await apiClient
      .get('/examsubject/');
    const examSubjects = await handleResponse(response);
    return examSubjects;
  } catch (error) {
    return error.response;
  }
}

async function updateExamSubject(examSubjectId, body) {
  try {
    const response = await apiClient
      .put(`/examsubject/${examSubjectId}`, body);
    const examSubject = await handleResponse(response);
    return examSubject;
  } catch (error) {
    return error.response;
  }
}

async function deleteExamSubject(examSubjectId, body) {
  try {
    const response = await apiClient
      .delete(`/examsubject/${examSubjectId}`, body);
    const examSubject = await handleResponse(response);
    return examSubject;
  } catch (error) {
    return error.response;
  }
}

const examSubjectServices = {
  addExamSubject,
  updateExamSubject,
  deleteExamSubject,
  getExamSubject,
  getAllExamSubjects,
};

export default examSubjectServices;
